import React from 'react';

import API from "@utilities/smart_api";

import ObjectIndex from "@components/Navigation/ObjectIndex";
import { User } from '@models';
import { Button } from '@mui/material';

const api = API.getInstance();

export default function UserIndex() {
  if (api.true_user && api.true_user.is_admin) {
    return (
      <ObjectIndex 
        data_type="user"
        // log_it
        extra_buttons={(user) => {
          console.log(user);
          if (user instanceof User) {
            return (
              <Button
                variant="contained" color="primary" 
                onClick={() => {
                  api.spoofUser(user);
                }}>
                Spoof User
              </Button>
            );
          }
          return null;
        }}
      />
    ); 
  }

  return <></>;
}